import React from "react";
import ReactDOM from "react-dom";
import cx from "classnames";
import BrandKindSelect from "@Components/common/singleBrandKindSelect/brandKindSelect";
import { ArticleType, NewsType } from "@Types/articles";
import Article from "@Components/article/listLink";
import { host } from "@Services/url";
import {
  fetchArticleNav,
  fetchNewsBanners,
  fetchRecommendColums,
  articleCategories,
  fetchV3Articles,
  fetchNewCarBrands,
  fetchNewCarKinds,
  fetchRecommendArticleChoice,
} from "../../services/article_v2";

import throttle from "lodash/throttle";
import { path, article } from "@Api";
import { get } from "@Lib/request";
import { Spin } from "antd";
import ga from "@Lib/ga";
import qs from "qs";
import styles from "./newsDeputy.module.less";
import "@Styles/global.less";
import HotArticle from "@Components/article/categoryArticle/HotArticle";

type NavType = {
  name: string;
  contentType1: undefined | string;
  contentType2: undefined | string;
  id: number;
};

interface IState {
  navList: NavType[];
  hotData: ArticleType[];
  bannersData: NewsType[];
  categoryData: any[];
  currentSlide: number;
  initArticleParams: any;
  newCarKind: any[];
  active: number;
  loadingMore: boolean;
  isShowLoadMore: boolean;
  isShowClear: boolean;
  data: any;
  newCarDataSource: IDataSource;
  params: IParams;
  count: number;
  animate: boolean;
  initId: number;
}

interface IDataSource {
  index: any[];
  brand: any[];
  kindNum: number;
}

interface IParams {
  brandId: undefined | number;
  kindId: undefined | number | "";
  contentType1: undefined | string;
  contentType2: undefined | string;
  filterNewest: undefined | number;
  type: undefined | string;
  limit: number;
}

let timeId = 0;
const { imageUrl } = path;
// const {
//     fetchArticleNav,
//     fetchNewsBanners,
//     fetchRecommendColums,
//     articleCategories,
//     fetchV3Articles,
//     fetchNewCarBrands,
//     fetchNewCarKinds,
//     fetchRecommendArticleChoice,
// } = article;

class News extends React.PureComponent<{}, IState> {
  readonly state: IState = {
    navList: [],
    hotData: [],
    bannersData: [],
    categoryData: [],
    currentSlide: 0,
    initArticleParams: { limit: 9, type: "1" },
    active: 0,
    loadingMore: false,
    isShowLoadMore: false,
    isShowClear: false,
    data: {
      dataSource: [],
      nextPage: "",
    },
    newCarKind: [],
    newCarDataSource: {
      index: [],
      brand: [],
      kindNum: 0,
    },
    params: {
      kindId: undefined,
      brandId: undefined,
      contentType1: undefined,
      contentType2: undefined,
      filterNewest: undefined,
      type: "1",
      limit: 9,
    },
    animate: true,
    count: 0,
    initId: 0,
  };

  private carouselRef = React.createRef<any>();

  private fixedNavRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.fetchSelect();
    this.fetchNav();
    this.fetchBanner();
    this.fetchArticleCategories();
    this.fetch(this.state.initArticleParams);
    this.init();
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    clearInterval(timeId);
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  private init() {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const nav = document.querySelector(".testcar-nav");

    nav && nav.remove();

    if (params.t) {
      this.setState({ initId: Number(params.t) });
    }
  }

  private fetchNav = async () => {
    const res = await fetchArticleNav();

    if (res && res.status === 12000) {
      const navs = res.data.nav?.filter((item) => item.name === "新聞");

      if (navs && Array.isArray(navs)) {
        const newsNav = navs[0]?.child ?? [];
        const list = [
          {
            name: "全部",
            contentType1: "新聞",
            contentType2: "",
            id: 0,
          },
        ].concat(
          newsNav
            .filter((item) => item.name !== "售後")
            .map((item) => ({
              name: item.name,
              contentType1: "新聞",
              contentType2: item.name,
              id: item.id,
            })),
        );

        this.setState(
          {
            navList: list,
          },
          () => {
            this.setTabForId(this.state.initId, list);
          },
        );
      }
    }
  };

  private fetchBanner = async () => {
    const bannerRes = await fetchNewsBanners({
      bannerLimit: 3,
      hotLimit: 5,
    });

    if (bannerRes && bannerRes.status === 12000) {
      this.setState({
        hotData: bannerRes.data.hot,
        bannersData: bannerRes.data.focus,
      });
      this.initHotScroll();
    }
  };

  private initHotScroll() {
    clearInterval(timeId);
    timeId = window.setInterval(() => {
      this.setState((prev) => {
        if (prev.count >= 4) {
          return {
            animate: false,
            count: 0,
          };
        }
        return { count: prev.count + 1, animate: true };
      });
    }, 3000);
  }

  private fetchArticleCategories = async () => {
    const categoryRes = await articleCategories({
      limit: 1,
      appendArticleLimit: 4,
    });

    if (categoryRes && categoryRes.status === 12000) {
      this.setState({
        categoryData: categoryRes.data.list,
      });
    }
  };

  private handleMouseEnter(inx: number) {
    const { current } = this.carouselRef;
    if (!current) {
      return;
    }
    current.goTo(inx);
    this.setState({ currentSlide: inx });
  }

  private fetch = async (params: Partial<IParams>) => {
    const res = await fetchV3Articles({ ...params });

    if (res && res.status === 12000) {
      this.setState((prev) => ({
        ...prev,
        data: {
          dataSource: res.data.list,
          nextPage: res.data.paging,
        },
        isShowLoadMore: !!res.data.list.length && !!res.data.paging,
      }));
    }
    this.setState({ loadingMore: false });
  };

  private setTabForId(id: number, navList: any[]) {
    if (id === undefined || id === NaN || navList.length === 0) return;

    const tab = navList.filter((item) => item.id === id);
    const inx = navList.findIndex((item) => item.id === id);

    if (tab.length !== 0 && inx !== -1) {
      const contentType1 = tab[0]?.contentType1;
      const contentType2 = tab[0]?.contentType2;

      this.setState((prev) => ({
        active: inx,
        params: { ...prev.params, contentType1, contentType2 },
      }));
      this.fetch({ ...this.state.params, contentType1, contentType2 });
    }
  }

  private setTab(data: NavType, inx: number) {
    const { id, contentType1, contentType2 } = data;

    this.setState((prev) => ({
      loadingMore: true,
      active: inx,
      params: { ...prev.params, contentType1, contentType2 },
    }));
    this.fetch({ ...this.state.params, contentType1, contentType2 });

    this.setUrl(id);
  }

  private setUrl(id: number) {
    const url = `/news?t=${id}`;
    const title = document.title;

    history.pushState({ url, title }, title, url);
  }

  private fetchSelect = async () => {
    const res = await fetchNewCarBrands();

    if (res && res.status === 12000) {
      this.setState({ newCarDataSource: res.data });
    }
  };

  private handleNewCarBrandSelect = async (brand: number) => {
    this.setState((prev) => ({
      ...prev,
      newCarKind: [],
      params: {
        ...prev.params,
        brandId: brand,
      },
    }));

    const res = await fetchNewCarKinds({ b: brand });

    if (res && res.status === 12000) {
      this.setState({
        newCarKind: res.data.data,
        isShowClear: true,
      });
    }
  };

  private loadMore = async () => {
    const { data } = this.state;

    if (!data.nextPage) return;

    this.setState({ loadingMore: true });

    const res = await get<any>(data.nextPage);

    this.setState({ loadingMore: false });

    if (res && res.status === 12000) {
      this.setState((prev) => ({
        ...prev,
        data: {
          dataSource: prev.data.dataSource.concat(res.data.list),
          nextPage: res.data.paging,
        },
        isShowLoadMore: !!res.data.list.length && !!res.data.paging,
      }));
    }
  };

  private handleScroll = throttle(() => {
    if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 380) {
      this.loadMore();
    }
  }, 500);

  private onSubmit = (data: any) => {
    if (data === "all") {
      this.setState((prev) => ({
        ...prev,
        params: {
          ...prev.params,
          kindId: "",
        },
        loadingMore: true,
      }));
      this.fetch({ ...this.state.params, kindId: "" });
      return;
    }

    const { brandId, kindId } = data;

    this.setState((prev) => ({
      ...prev,
      params: {
        ...prev.params,
        brandId,
        kindId,
      },
      loadingMore: true,
    }));
    this.fetch({ ...this.state.params, brandId, kindId });
  };

  render() {
    const {
      navList,
      bannersData,
      hotData,
      currentSlide,
      categoryData,
      data,
      newCarDataSource,
      newCarKind,
      params,
      isShowClear,
      loadingMore,
      isShowLoadMore,
      active,
      count,
      animate,
    } = this.state;

    return (
      <div className={styles["news"]} key='fb4f2242c7e'>
        <div className={styles["news-top"]}>
          <div className={styles["wrapper"]}>
            <div className={styles["top"]}>
              <img className={styles["news-img"]} src={`${imageUrl}/article/news/icon1.svg`} alt='' />
              <p></p>
              <div className={styles["hot"]}>
                <img className={styles["hot-img"]} src={`${imageUrl}/article/news/icon3.png`} alt='' />
                <div className={styles["hot-wrapper"]}>
                  <ul
                    className={cx(styles["hot-list"], {
                      [styles["animate"]]: animate,
                    })}
                    style={{
                      display: "block",
                      transform: `translate3d(0, -${count * 60}px, 0)`,
                    }}
                  >
                    {hotData &&
                      hotData.map((item, inx) => (
                        <li className={styles["hot-item"]} key={inx}>
                          <a target='_blank' href={item.link}>
                            {item.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className={styles["all-article-bar"]}>
              <div
                className={cx(styles["article-nav"], {
                  [styles["small-nav"]]: navList.length > 5,
                })}
              >
                {navList &&
                  navList.length !== 0 &&
                  navList.map((item, inx) => (
                    <a
                      className={cx(styles["nav-item"], {
                        [styles["active"]]: active === inx,
                      })}
                      key={inx}
                      href={`/news${item.id ? `?t=${item.id}` : ""}`}
                    >
                      {item.name}
                    </a>
                  ))}
              </div>
              <div className={styles["brand-select"]}>
                <BrandKindSelect
                  border
                  field={"newcar"}
                  selectLabel={"選擇廠牌車款"}
                  dataSource={newCarDataSource}
                  kindData={newCarKind}
                  onBrandSelect={this.handleNewCarBrandSelect}
                  onClear={() => {
                    this.setState((prev) => ({
                      params: {
                        ...params,
                        kindId: undefined,
                        brandId: undefined,
                      },
                      isShowClear: false,
                      loadingMore: true,
                    }));
                    this.fetch({
                      ...params,
                      kindId: undefined,
                      brandId: undefined,
                    });
                  }}
                  isShowClear={isShowClear}
                  onSubmit={this.onSubmit}
                />
              </div>
            </div>
            <div className={styles["top-news"]}>
              <div className={styles["left-wrapper"]}>
                <div className={styles["all-article-container"]}>
                  <Spin spinning={loadingMore}>
                    {data.dataSource.map((item) => (
                      <Article dataSource={item} key={item.id} itemStyle={{ background: "#fff" }} />
                    ))}
                  </Spin>
                </div>
                <div className={styles["all-article-footer"]}>
                  {isShowLoadMore && (
                    <a className={styles["footer-next"]} onClick={this.loadMore}>
                      {loadingMore ? "正在加载中..." : "加載更多"}
                      <Spin spinning={loadingMore}></Spin>
                    </a>
                  )}
                  {data.dataSource.length === 0 && <p className={styles["footer-none"]}>車款暫無相關文章</p>}
                </div>
              </div>
              <div className={styles["right"]}>
                <div
                  gad='div-gpt-ad-1508319522490-110'
                  gad-tag='/173427088/newcar_pc_news_list'
                  className='dfp-fluid dfp-h5'
                  style={{
                    height: "560px",
                    width: "280px",
                    marginBottom: "20px",
                    display: "none",
                  }}
                ></div>
                <iframe
                  src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F8891newcar%2F&width=280&height=160&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId'
                  width='280'
                  height='160'
                  style={{
                    border: "none",
                    overflow: "hidden",
                  }}
                  scrolling='no'
                  frameBorder='0'
                  allowFullScreen={true}
                  allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
                ></iframe>

                <HotArticle
                  title='精選推薦'
                  fetchData={fetchRecommendArticleChoice}
                  fetchParams={{
                    limit: 10,
                    position: "newsHome",
                  }}
                  style={{ padding: "0 0 40px 0" }}
                />

                <div className={styles["category"]}>
                  <div className={styles["category-box"]}>
                    <h3>
                      <p>
                        <i>HOT</i>精華合輯
                      </p>
                      <a href={`${host.c}/feature`}>更多</a>
                    </h3>
                    {categoryData &&
                      categoryData.map((item, inx) => (
                        <div className={styles["category-content"]} key={inx}>
                          <a className={styles["category-tile"]} href={`/feature/${item.id}`} target='_blank'>
                            <img className={styles["category-img"]} src={item.thumb} alt='' />
                            <p>#{item.title}</p>
                          </a>
                          <ul className={styles["category-list"]}>
                            {item.articles &&
                              item.articles.map((ii, i) => (
                                <a
                                  target='_blank'
                                  href={`${ii.link}?ca_id=${item.id}`}
                                  className={styles["category-item"]}
                                  key={i}
                                >
                                  {ii.title}
                                </a>
                              ))}
                          </ul>
                        </div>
                      ))}
                  </div>
                </div>
                {/* <a className={styles['news-line']} target="_blank" href="/compaigns/line-guide">
                  <img src={`${imageUrl}/article/news/png5.png`} alt="" />
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className={styles["news-container"]}>
          <div className={styles["article-left"]}>
            <div className={styles["left-top"]}></div>
          </div>
          <div className={styles["article-right"]}></div>
        </div>
      </div>
    );
  }
}

export default News;
